// extracted by mini-css-extract-plugin
module.exports = {"alert":"_3DQ5Da_I","close":"_3oSI77yT","danger":"_1XX0ztqh"};